import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { ObjetoPrensa } from '../model/ObjetoPrensa';
import { ObjetoExtra } from '../model/ObjetoExtra';
import { Observable } from 'rxjs';
import { PaginatedResult } from '../model/PaginatedResult';

@Injectable({
  providedIn: 'root',
})
export class PrensaService {

  constructor(private http: HttpClient) { }

  getNotas(page: number): Observable<PaginatedResult<ObjetoPrensa>> {
    return this.http.get<PaginatedResult<ObjetoPrensa>>(`${environment.apiUrl}/prensa?page=${page + 1}`);
  }

  // todo: mover esto a otro servicio?
  getExtras(page: number): Observable<PaginatedResult<ObjetoExtra>> {
    return this.http.get<PaginatedResult<ObjetoExtra>>(`${environment.apiUrl}/extras?page=${page + 1}`);
  }
}

